import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { ExchangeType, CacheService } from '@mapfre-tech/amap3';
import { Observable, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class ExchangeTypeService {

   className = 'ExchangeTypeService'

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllExchanges(cache = true, cacheKey = "allExchanges"): Observable<ExchangeType[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get<ExchangeType[]>(environment.base_URL + "/exchange-types").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newExchange(exchange: any) {
      return this.http.post(environment.base_URL + "/exchange-types", exchange).pipe(tap(() => this.deleteCache()))
   }

   updateExchange(exchange: any, id: any) {
      return this.http.put(environment.base_URL + `/exchange-types/${id}`, exchange).pipe(tap(() => this.deleteCache()))
   }

   deleteExchange(id: number) {
      return this.http.delete(environment.base_URL + `/exchange-types/${id}`).pipe(tap(() => this.deleteCache()))
   }

   importExchanges(exchanges: any[]) {
      return this.http.post(environment.base_URL + "/exchange-types/import", exchanges).pipe(tap(() => this.deleteCache()))
   }

   deleteCache() {
      this.cacheService.deleteCache('allExchanges');
   }

}
